import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { useAuthenticationStore } from '../stores/Authentication';
import { mfaLoginResultsState, withoutErrors } from '../stores/mfa-login';

/**
 * Forgets persisted MFA login failures whenever there is no session, keeping the successes.
 *
 * Renders nothing and exists only to own that effect: signing out is a client-side navigation, so
 * the document is never reloaded and the Recoil store has to be pruned explicitly. It has to sit
 * inside `RecoilRoot`, which rules out `App`'s own body.
 */
const MfaLoginErrorCleanup = () => {
  const {
    state: { hasAccess },
  } = useAuthenticationStore();
  const setResults = useSetRecoilState(mfaLoginResultsState);

  useEffect(() => {
    if (!hasAccess) setResults(withoutErrors);
  }, [hasAccess, setResults]);

  return null;
};

export default MfaLoginErrorCleanup;
